import React from "react";
import { PageHeader } from "./PageHeader";
import agh100 from "../img/agh100.png";

export const AGHDay = props => {
  return (
    <React.Fragment>
      <PageHeader title='Dzień "100 lat Fizyki na AGH" '  />
      <div className="content-wrapper">
        <div className="main-content aghday">
            <div className="row">
                <img src={agh100} alt="100 lat agh"/>
                <div className="info-agh">
                        W poniedziałek 16 września, obrady Zjazdu Fizyków Polskich odbędą się w siedzibie Akademii Górniczo - Hutniczej im. Stanisława Staszica w Krakowie.
                        Przebiegać będą pod hasłem "100 lat fizyki na AGH", wpisując się w kalendarz obchodów jubileuszu stulecia Uczelni.
                        W trakcie sesji plenarnej Prof. Wojciech Łużny, Rektor AGH, przedstawi w pigułce historię stu lat fizyki na AGH. Motywem przewodnim obrad będą
                        innowacje i związki fizyki z przemysłem, medycyną i naukami społecznymi. Prof. Franciszek Hennel z Uniwersytetu i Politechniki w Zurichu wygłosi
                        referat nt. wkładu fizyki do medycyny na przykładzie metod obrazowania. Dr Przemysław Repetowicz z firmy Probability Dynamics w Dublinie opowie
                        o podejmowanych przez fizyków próbach zrozumienia mechanizmów giełdowych. Dr Andreas Glenz, prezes firmy Prevac, wygłosi referat nt. innowacyjnych
                        osiągnięć polskiego przemysłu i ich związku z fizyką. Prof. Kazimierz Różański z AGH przedstawi perspektywy spowolnienia efektu globalnego ocieplenia,
                        a Prof. Karol Życzkowski z Uniwersytetu Jagiellońskiego wygłosi referat o fizycznym podejściu do szerokiego spektrum zagadnień - od teorii wyboru
                        społecznego poprzez ekonofizykę do informacji kwantowej. Związki z przemysłem, medycyną, innowacjami i naukami społecznymi będą również prezentowane
                        podczas popołudniowych sesji równoległych. W trakcie sesji "Fizyka - Przemysł - Innowacje" referaty przedstawią przedstawiciele Polskich Zakładów
                        Lotniczych, firm Airly i Nemak Polska, Centrum Badań i Rozwoju Technologii dla Przemysłu oraz Akademii Górniczo - Hutniczej.
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12">
                    <br/>
                    <h4 className="h4">Sesje plenarne (poniedziałek 9:00 - 13:30)</h4>
                    <table className="table table-striped konfd">
                        <thead>
                        <tr>
                            <th>Nr sesji</th>
                            <th>Nazwa sesji</th>
                            <th>Miejsce</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>P6</td>
                            <td>Sejsa plenarna 9:00  - 11:00</td>
                            <td>Klub Studio (ul. Budryka 4)</td>
                        </tr>
                        <tr className="alert-primary">
                            <td></td>
                            <td>Przerwa kawowa 11:00-11:30</td>
                            <td>Klub Studio (ul. Budryka 4)</td>
                        </tr>
                        <tr>
                            <td>P7</td>
                            <td>Sejsa plenarna 11:30  - 13:30</td>
                            <td>Klub Studio (ul. Budryka 4)</td>
                        </tr>
                        <tr className="alert-primary">
                            <td></td>
                            <td>Przerwa obiadowa 13:30 - 15:00</td>
                            <td>Klub Studio (ul. Budryka 4)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12">
                    <h4 className="h4">Sesje równoległe (poniedziałek 15:00 - 17:00)</h4>
                    <table className="table table-striped konfd">
                        <thead>
                        <tr>
                            <th>Nr sesji</th>
                            <th>Nazwa sesji</th>
                            <th>Miejsce</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>S1</td>
                            <td>Fizyka medyczna i biofizyka</td>
                            <td>Sala 18 (Pawilon D-11)</td>
                        </tr>
                        <tr>
                            <td>S2</td>
                            <td>Nanofizyka i nanotechnologia</td>
                            <td>Sala ACMIN (Pawilon D-16)</td>
                        </tr>
                        <tr>
                            <td>S4</td>
                            <td>Fizyka cząstek</td>
                            <td>Sala B (Pawilon D-10)</td>
                        </tr>
                        <tr>
                            <td>S9</td>
                            <td>Fizyka układów złożonych</td>
                            <td>Sala C (Pawilon D-10)</td>
                        </tr>
                        <tr>
                            <td>S11</td>
                            <td>Fizyka środowiska</td>
                            <td>Sala D (Pawilon D-10)</td>
                        </tr>
                        <tr>
                            <td>S12</td>
                            <td>Sesja "Fizyka-Przemysł-Innowacje""</td>
                            <td>Sala A (Pawilon D-10)</td>
                        </tr>

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  );
};

AGHDay.propTypes = {};
